//@flow

export const getFlagUrl = (flagCode: string): string =>
  `https://static.rfstat.com/renderforest/images/website_maker_images/flags/${flagCode}.svg`
